module.exports = __webpack_public_path__ + "static/media/hubspotHero2x.46a1264e.png";